import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { countryAssets } from "../config/countryAssets";

const PubZone = () => {

    const DEPLOYED_COUNTRIES = [
        'BJ', // Benin
        //'BF',  Burkina Faso
        //'CV', // Cape Verde
        'CI', // Côte d'Ivoire
        //'GM', // Gambia
        'GH', // Ghana
        //'GN', // Guinea
        //'GW',  //Guinea-Bissau
        //'LR', // Liberia
        //'ML', // Mali
        //'MR',  // Mauritania
        //'NE', // Niger
        'NG', // Nigeria
        'SN', // Senegal
        //'SL',  // Sierra Leone
        'TG',  // Togo
        'CM', // Cameroon
        //'MA',
        //'ZA'
    ];

    const country = useSelector((state) => state.country.country);
    const countryCode = country?.value;

    const isDeployed = DEPLOYED_COUNTRIES.includes(countryCode);

    const assets = isDeployed
        ? countryAssets[countryCode]
        : countryAssets.DEFAULT;

    // 👉 tableau des images
    const banners = (assets.pubBanners || []).filter(Boolean);

    const safeBanners = banners.length > 0
        ? banners
        : [assets.firstPubBanner || assets.pubBanner || "images/background-images/default-banner.png"];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (safeBanners.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % safeBanners.length);
        }, 11000);

        return () => clearInterval(interval);
    }, [safeBanners.length]);

    useEffect(() => {

        safeBanners.forEach((banner) => {
            const img = new Image();
            img.src = `/${banner}`;
        });

    }, [safeBanners]);

    return (
        <div className="pub-slider-container">

            {safeBanners.map((banner, index) => (
                <div
                    key={index}
                    className={`pub-slide ${
                        index === currentIndex ? "active" : ""
                    }`}
                    style={{
                        backgroundImage: `url(/${banner})`
                    }}
                />
            ))}

        </div>
    );
};

export default PubZone;